import React, { Component } from 'react';

import QuestionList from './QuestionList/';
import NoteCanvas from './NoteCanvas/';
import NotePreview from './NotePreview/';

const CURRENT_STEP = 'HPI_BUILDER';

class NoteBuilder extends Component {
  render() {
    if (this.props.currentStep !== CURRENT_STEP) {
      return null;
    }

    return (
      <div className="row">
        <div className="col-lg-3 offset-lg-2">
          <QuestionList />
        </div>

        <div className="col-lg-5">
          <div className="col mb-3">
            <NoteCanvas />
          </div>

          <div className="col">
            <NotePreview />
          </div>
        </div>


      </div>
    )
  }
}


export default NoteBuilder;